import { Dynamicore } from './dynamicore/dynamicore';
import { SERVICES } from './dynamicore/constants';

export const lookupFieldAction = async (source, value) => {
  let response;
  if (source.type === 'zipcode' || source.type === 'zipcode_cnbv') {
    response = await Dynamicore(source.type === 'zipcode' ? SERVICES.CATALOGS_ZIPCODE : SERVICES.CATALOGS_ZIPCODE_CNBV).get({
      codigo: String(value),
      ...(source.type === 'zipcode_cnbv' ? {
        limit: 500,
        page: 1,
      } : {}),
    });
  } else if (source.type === 'catalog') {
    response = await Dynamicore(SERVICES.CATALOGS_FIELDS).get({
      catalog: source.catalog,
      ...(source.element ? {
        fields: source.element,
      } : {}),
      [source.queryParam]: value,
    }, false, true);
  } else throw new Error('Unknown action source');
  return response?.values || [];
};
